import Vue from 'vue'
import VueRouter from 'vue-router'
import Routes from './routes'
import * as uiv from 'uiv'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VueTouch from 'vue-touch'
import VueAnalytics from 'vue-analytics'
import VeeValidate from 'vee-validate'
import VueFire from 'vuefire'
import Promise from 'es6-promise'

// Import Bootstrap CSS
import './css/bootstrap.min.css'
// Import global config
import GlobalConfig from './config'
// Import static data (translations, etc)
import StaticData from '@/data/cms.json'

// Import global plugims
import UrlPlugin from './plugins/url'
import Translation from './plugins/translation'
import PageTitle from './plugins/pagetitle'
import ImagePath from './plugins/imagepath'
import ImageResize from './plugins/imageresize'
import Background from './plugins/background'
import TitleCase from './plugins/titlecase'
import Timebomb from './plugins/timebomb'
import ArticleUrl from './plugins/articleUrl'
import PollUrl from './plugins/pollUrl'

// API call
import api from '@/api'

// Import main component
import App from './App'

// Init
Vue.use(VueRouter)
Vue.use(uiv)
Vue.use(GlobalConfig)
Vue.use(UrlPlugin)
Vue.use(Translation)
Vue.use(PageTitle)
Vue.use(ImagePath)
Vue.use(ImageResize)
Vue.use(Background)
Vue.use(TitleCase)
Vue.use(Timebomb)
Vue.use(ArticleUrl)
Vue.use(PollUrl)
Vue.use(VueLodash, lodash)
Vue.use(VueTouch)
Vue.use(VeeValidate)
Vue.use(VueFire)
// Vue.use(VModal)
// Vue.use(VueShortkey)

// console.log('GlobalConfig: ', GlobalConfig);

window.Promise = Promise

/****************************************/
/********** Router START here **********/
/**************************************/
const router = new VueRouter({
  routes: Routes,
})

router.beforeEach((to, from, next) => {
  // console.log('global beforeEach')
  next()
})

let host = window.location.host.split('.')[0]
if (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) {
  Vue.use(VueAnalytics, {
    id: 'UA-108612405-1',
    router,
  })
} else {
  Vue.use(VueAnalytics, {
    id: 'UA-109723812-1',
    beforeFirstHit() {
      Vue.$ga.set('anonymizeIp', true)
    },
    router,
  })
}

/* eslint-disable */
window.Event = new Vue()

/* eslint-disable */
if (document.getElementById('app')) {
  new Vue({
    el: '#app',
    render: h => h(App),
    router: router,
    data() {
      return {
        StaticData,
        bgimage: null,
        windowWidth: 0,
        region: null,
        navitems: [],
        navigationId: null,
      }
    },
    created() {
      const vm = this
      setTimeout(function() {
        vm.getRegion()
        vm.getNavItems()
      }, 1000)
    },
    mounted() {
      // console.log('main.js mounted')
      api.getToken()
      // this.getNavItems()
      // Get the current viewport width
      this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth)

        // Init
        this.getWindowWidth()
      })
      // console.log('item: ', this.computedNavId)
      // console.log('navitems: ', this.navitems)

    },
    methods: {
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      },
      getRegion() {
        // Get route region
        let region = this.$route.params.region
        if (region === undefined) {
          // region = null
          region = 'verband'
        }

        if (region) {
          region = `${region.toLowerCase()}`
        }

        console.log('getRegion: ', region)

        // write region to data object
        this.region = region
      },
      getNavItems() {
        const vm = this
        console.log('getNavItems region: ', vm.region)
        api
          .loadNavigationNew(vm.region)
          .then(data => {
            console.log('main.js: getNavItems', vm.region)

            this.navitems = api.parseNavigation(data.data)

            let i = 0
            this.navitems.forEach(item => {
              // console.log('i: ', i)

              if (i === 0) {
                // console.log('item: ', item.sys.id)
                this.navigationId = item.sys.id
              }

              // Parent
              if (item.hasOwnProperty('fields') && item.fields.hasOwnProperty('url') && item.fields.url !== null) {
                if (!item.fields.url.indexOf('http')) {
                  item.fields.searchURL = item.fields.url
                } else if (!item.fields.url.indexOf('File')) {
                  item.fields.linkURL = `${item.fields.url.split('File:')[1]}`
                } else {
                  item.fields.linkURL = item.fields.url
                }
              }

              // Children
              if (item.hasOwnProperty('navigationItems') && !!item.navigationItems) {
                item.navigationItems.forEach(itm => {
                  if (itm.hasOwnProperty('fields') && itm.fields.hasOwnProperty('url') && itm.fields.url !== null) {
                    if (!itm.fields.url.indexOf('http')) {
                      itm.fields.linkURL = itm.fields.url
                    } else if (!itm.fields.url.indexOf('File')) {
                      itm.fields.linkURL = `${itm.fields.url.split('File:')[1]}`
                    } else {
                      itm.fields.searchURL = itm.fields.url
                    }
                  }
                })
              }

              // increment
              i++
            })
          })
          .catch(error => {
            api.errorHandling(error, `Topbar.vue - Navigation @ ${window.location.href}`)
          })
      }
    },
    computed: {
      computedNavId() {
        return 'test'
      }
    },
  })
}



// WEBPACK FOOTER //
// ./src/main.js